module.exports = __webpack_public_path__ + "static/media/ic_error_message.5f654f3c.svg";